export const NAME_ADDRESS_LOGIN_INITIATE = 'NAME_ADDRESS_LOGIN_INITIATE';
import { NameAddressPayload } from '@src/app/login/types';

export type Actions = {
  NAME_ADDRESS_LOGIN_INITIATE: {
    type: typeof NAME_ADDRESS_LOGIN_INITIATE;
    payload: NameAddressPayload;
  };
};

// Action Creators
export const actionCreators = {
  nameAddressLogin: (
    payload: NameAddressPayload,
  ): Actions[typeof NAME_ADDRESS_LOGIN_INITIATE] => ({
    type: NAME_ADDRESS_LOGIN_INITIATE,
    payload,
  }),
};
